import {
  ExternalConnection,
  ExternalConnectionsCapabilities,
} from '@griply/types';

export const canConnectionWriteEvents = (
  connection: ExternalConnection,
): boolean =>
  !!connection.capabilities?.includes(
    ExternalConnectionsCapabilities.WriteEvents,
  );
